
import { WDFormBasic } from './wd-form-basic';
import WDButton from '../button/wd-button';

export class WDFormButton extends WDFormBasic {

  #value = null;
  #button = null;
  
  constructor(opts)
  {
  	const cfg = { 
  		theme: 'clear',
  		icon: 'fa-solid fa-edit',
  		handler: null,
  		value: null,
  		type: 'button',
  		templates: {
  			label: '${label}',
  			value: '${value}'
			},
		};
		
		//merge in the passed configs
		Object.assign(cfg,opts);
		
		const btn = new WDButton({label:'Not Selected',theme:cfg.theme});

    super(btn,cfg);
		this.#button = btn;
		
		if (cfg.icon) this.#button.icon = cfg.icon;
		if (cfg.handler) this.#button.on('click',cfg.handler);
		if (cfg.value && Object.keys(cfg.value).length > 0) this.value = cfg.value;

		if (cfg?.readonly) this.#button.disabled = true;
	};

	get button() { return this.#button; };

	get value() { return this.#value; };
	set value(data)
	{
		const oldVal = this.#value;
		//if templates.value is set to null, store the whole object
		this.#value = this.config.templates?.value !== null ? this.config.templates.value.interpolate(data) : data;

		this.#button.label = (data !== null) ? this.config.templates.label.interpolate(data) : 'Not Selected';
		
		this.trigger('value:set');
		if (oldVal != this.#value) this.trigger('change');
	};

	cleanupCallback()
	{
		// Clean up button
		if (this.#button) {
			this.#button = null;
		}

		this.#value = null;

		super.cleanupCallback();
	}

};

customElements.define('wd-form-button',WDFormButton);
